import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiLink, FiUser } from "react-icons/fi";
import AccountNav from "./AccountNav";
import { customers, formatAccountDate } from "../Datas/accountData";
import siteConfig from "../config/siteConfig";
import "../css/account.scss";

function Customers() {
  useEffect(() => {
    document.title = `Customers — ${siteConfig.brandName}`;
  }, []);

  return (
    <main className="account-page">
      <div className="shell">
        <AccountNav />
        <header className="account-heading">
          <div>
            <p className="eyebrow">ERP directory</p>
            <h1>Customers</h1>
          </div>
          <p>Buyer records and connected storefronts.</p>
        </header>
        <section className="customer-list" aria-label="Customer list">
          {customers.map((customer) => (
            <article key={customer.id}>
              <span className="customer-list__avatar">
                <FiUser />
              </span>
              <div className="customer-list__name">
                <small>Customer</small>
                <strong>{customer.name}</strong>
                <p>{customer.address}</p>
              </div>
              <div>
                <small>First visit</small>
                <span>{formatAccountDate(customer.firstVisit)}</span>
              </div>
              <div>
                <small>Status</small>
                <span className="status-badge status-badge--success">
                  {customer.status}
                </span>
              </div>
              <div>
                <small>Store</small>
                {customer.storeUrl ? (
                  <a
                    href={customer.storeUrl}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={`Visit ${customer.name} store`}
                  >
                    <span className="status-badge status-badge--pending">
                      <FiLink /> {customer.storeLabel || customer.storeUrl}
                    </span>
                  </a>
                ) : (
                  <span className="status-badge status-badge--pending">
                    <FiLink /> Link pending
                  </span>
                )}
              </div>
              <Link
                to={`/customers/${customer.id}`}
                aria-label={`View ${customer.name}`}
              >
                View customer <FiArrowRight />
              </Link>
            </article>
          ))}
        </section>
      </div>
    </main>
  );
}

export default Customers;
